import { useFeatureToggle } from "@hooks/useFeatureToggle";

import type {
  Payload,
  DataLayer,
  GTMWindowWithPush,
  GTMWindowWithDataLayer,
} from "./useGTM.types";

export const useGTM = () => {
  const isGTMEnabled = useFeatureToggle("gtm");

  const push = (payload: Payload): void => {
    const gtmWindow = (window || {}) as GTMWindowWithPush | undefined;

    if (!isGTMEnabled || typeof gtmWindow?.dataLayer?.push !== "function") {
      return;
    }

    gtmWindow.dataLayer.push(payload);
  };

  const getDataLayer = (): DataLayer | null => {
    const gtmWindow = (window || {}) as GTMWindowWithDataLayer | undefined;

    if (isGTMEnabled && !!gtmWindow && Array.isArray(gtmWindow.dataLayer)) {
      return gtmWindow.dataLayer;
    }

    return null;
  };

  return {
    isGTMEnabled,
    push,
    getDataLayer,
  };
};
